import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { OAuthResponse } from '../models/authentication.model';

@Injectable({ providedIn: 'root' })
export class Auth0Service {

  private readonly http: HttpClient;

  constructor() {
    this.http = inject(HttpClient);
  }

  public getPasswordGrantCredentials(email: string, password: string): Observable<OAuthResponse> {
    return this.http.post(`${environment.auth0Config.tenantUrl}/oauth/token`, {
      client_id: `${environment.auth0Config.clientId}`,
      realm: `${environment.auth0Config.realm}`,
      username: email,
      password,
      grant_type: 'password',
      scope: `${environment.auth0Config.scope}`,
      audience: `${environment.auth0Config.audience}`
    });
  }

  public refreshToken(refreshToken: string): Observable<OAuthResponse> {
    return this.http.post(`${environment.auth0Config.tenantUrl}/oauth/token`, {
      client_id: `${environment.auth0Config.clientId}`,
      realm: `${environment.auth0Config.realm}`,
      refresh_token: refreshToken,
      grant_type: 'refresh_token'
    });
  }

}
